import React, { useEffect, useState } from "react";
import { Prompt, Route, useLocation } from "react-router-dom";
import "../../App.css";
import "react-toastify/dist/ReactToastify.css";
import Dashboard from "../../screens/Dashboard/Dashboard";
import Distributors from "../../screens/Distributors/Distributors";
import ApprovalRequests from "../../screens/ApprovalRequests/ApprovalRequests";
import ContentPage from "../../screens/ContentPage/ContentPage";
import ReportPage from "../../screens/Reports/ReportPage";
import DistributorProfile from "../../screens/Distributors/DistributorProfile";
import Navigation from "../../common/Sidebar/Navigation";
import Header from "../../common/Header/Header";
import { UserTypes } from "../../constants/user-types";
import { useAuth } from "../../hooks/useAuth";
import Login from "./Login";
import LandingPage from "../../screens/LandingPage/LandingPage";
import ManageRoles from "../../screens/ManageRoles/ManageRoles";
import ConfirmApproval from "../../screens/ConfirmApproval/ConfirmApproval";
import ConfirmSignup from "../../screens/ConfirmSignup/ConfirmSignup";
import CatalogPage from "../../screens/Catalog/CatalogPage";
import { usePageMode } from "../../hooks/usePageMode";
import { exitConfirmationMessage } from "../../screens/Distributors/constants";
import BundlePage from "../../screens/Bundle/BundlePage";
import { useCatalogContext } from "../../screens/Distributors/Catalog/Catalog.context";
import { useContentContext } from "../../screens/Distributors/Content/Content.context";
import { MODE, TABS } from "../../constants/common";
import { useBundleContext } from "../../screens/Distributors/Bundle/Bundle.context";
import ManageModules from "../../screens/ManageModules/ManageModules";
import ForgotPassword from "./ForgotPassword";
import ActivateUser from "./ActivateUser";
import SecureRoute from "./SecureRoute";
import SSOProtectedRoute from "./SSOProtectedRoute";
import ManageDocuments from "../../screens/ManageDocuments/ManageDocuments";
import SignUpPage from "./SignUpPage";
import Share from "./Share";
import { useHistory } from "react-router";
import ManageSettings from "../../screens/ManageSettings/ManageSettings";
import PaymentComponent from "./PaymentComponent";
import Access from "../../screens/Distributors/SubscriberAccess/Access";
import SetupComponent from "./SetupComponent";
import Vendors from "../../screens/Vendors/Vendors";
import AddEditVendor from "../../screens/Vendors/AddEditVendor";
import AddEditIntSolution from "../../screens/VendorIntegrationSolutions/AddEditIntSolution";
import ReusableLink from "./ReusableLink";
import PurchasePage from "../../screens/WebPayment/Purchase/PurchasePage";
import CartPage from "../../screens/WebPayment/Purchase/Cart/CartPage";
import EGCartPage from "../../screens/WebPayment/Purchase/Cart/EGCartPage";
import ContentPreviewPage from "../../screens/WebPayment/Purchase/ContentPreviewPage";
import CatalogContentList from "../../screens/WebPayment/Purchase/CatalogContentList";
import SSOCallback from "../../screens/WebPayment/Purchase/SSO/SSOCallback";
import PaymentProcessing from "../../screens/WebPayment/Purchase/PaymentProcessing/PaymentProcessing";
import PaymentSuccess from "../../screens/WebPayment/Purchase/PaymentSuccess/PaymentSuccess";
import SessionExpired from "../../screens/WebPayment/SessionExpired/SessionExpired";
import { SsoCartProvider } from "../../contexts/SsoCartContext";
import { EgCartProvider } from "../../contexts/EGcartContext";
import AddInsList from "../../screens/AddInsServices/AddInsList";
import AddEditServices from "../../screens/AddInsServices/AddInsServices";
import AddInPayment from "../../screens/AddInsServices/AddInPayment";
import AddInsServiceConfiguration from "../../screens/AddInsServices/AddInsServiceConfiguration";
import EGPaymentSuccess from "../../screens/WebPayment/Purchase/PaymentSuccess/EGPaymentSuccess";
import EGPaymentProcessing from "../../screens/WebPayment/Purchase/PaymentProcessing/EGPaymentProcessing";
import PurchaseAddInsDetailsPage from "../../screens/WebPayment/Purchase/SubscriberAddins/PurchaseAddInsDetailsPage";
import PurchaseMyAddInsDetailsPage from "../../screens/WebPayment/Purchase/SubscriberAddins/PurchaseMyAddInsDetailsPage";
import AdvBannersFormula from "../../screens/AdManagement/AdvBannersFormula";
import AdPaymentSuccess from "../../screens/AdManagement/PaymentSuccess/AdPaymentSuccess";
import CommonSuccess from "../../screens/CommonSuccess/CommonSuccess";
import { useProSidebar } from "react-pro-sidebar";
import {
  getDocumentTitle,
  isTitleManagedByPage,
} from "../../utilities/documentTitle";

const PrivateRoute = () => {
  const auth = useAuth();
  const page = usePageMode();
  const history = useHistory();
  const location = useLocation();
  const [show, setShow] = useState(false);
  const user = auth.getCurrentUser();
  const isAuth = user !== null;
  const selectedRole = auth.getRole();
  const catalogContext = useCatalogContext();
  const contentContext = useContentContext();
  const bundleContext = useBundleContext();
  const { setDirty, setBreadcrumbRoute } = page;
  const { collapsed } = useProSidebar();
  useEffect(() => {
    if (selectedRole) {
      const pathsToHideNavigation = [
        "/share",
        "/payment",
        "/setuppayment",
        "/purchase",
        "/sso",
        "/payment-process",
        "/payment-success",
        "/session-expired",
      ];
      const shouldHideNav = pathsToHideNavigation.some((path) =>
        location.pathname.includes(path),
      );
      setShow(!shouldHideNav);
    } else {
      setShow(false);
    }
  }, [selectedRole, location.pathname]);

  useEffect(() => {
    if (!isTitleManagedByPage(location.pathname)) {
      document.title = getDocumentTitle(location.pathname);
    }
  }, [location.pathname]);

  useEffect(() => {
    // After confirm/Cancel reset dirty flag
    page.setDirty(false);
    setDirty(false);
    catalogContext.setSelectedTab(TABS.CATALOG);
    catalogContext.setCatalogMode(MODE.LIST);
    contentContext.setSelectedTab(TABS.CONTENT);
    contentContext.setContentMode(MODE.LIST);
    bundleContext.setSelectedTab(TABS.BUNDLE);
    bundleContext.setBundleMode(MODE.LIST);
    let locationArr = location.pathname.split("/").filter(Boolean);
    page.setBreadcrumbRoute(locationArr);
    setBreadcrumbRoute(locationArr);
  }, [
    location.pathname,
    setDirty,
    setBreadcrumbRoute,
    catalogContext,
    contentContext,
    bundleContext,
  ]);
  const authState = !!localStorage.getItem("loginData");
  const beforeLoginURL = ["/", "/reset-password", "/activate", "/signup"];
  if (beforeLoginURL.includes(location.pathname) && authState) {
    history.push("/login");
  }

  return (
    <div>
      <div className={`${show ? "main-container" : ""}`}>
        {show && <Navigation />}
        <div
          className={`${show ? "app-container" : ""} ${collapsed ? "collapsed" : "expanded"}`}
        >
          {page.isDirty && (
            <Prompt when={page.isDirty} message={exitConfirmationMessage} />
          )}
          <div className="header">{show && <Header />}</div>
          <Route exact path="/" component={Login} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/share/:id" component={Share} />
          <Route exact path="/reusable-link/:id" component={ReusableLink} />
          <Route exact path="/payment/:id" component={PaymentComponent} />
          <Route
            exact
            path="/ad-payment-success/:id"
            component={AdPaymentSuccess}
          />
          <Route exact path="/success" component={CommonSuccess} />
          <Route exact path="/setuppayment/:id" component={SetupComponent} />
          <Route exact path="/reset-password" component={ForgotPassword} />
          <Route exact path="/activate" component={ActivateUser} />
          <Route exact path="/signup" component={SignUpPage} />
          <Route exact path="/sso/callback" component={SSOCallback} />
          <Route exact path="/payment-process" component={PaymentProcessing} />
          <EgCartProvider>
            <Route exact path="/cart/checkout" component={EGCartPage} />
            <Route
              exact
              path="/eg-payment-success"
              component={EGPaymentSuccess}
            />
            <Route
              exact
              path="/eg-payment-process"
              component={EGPaymentProcessing}
            />
          </EgCartProvider>
          <Route exact path="/session-expired" component={SessionExpired} />
          <SsoCartProvider>
            <Route exact path="/payment-success" component={PaymentSuccess} />
            <SSOProtectedRoute
              exact
              path="/purchase"
              component={PurchasePage}
            />
            <SSOProtectedRoute path="/purchase/cart" component={CartPage} />
            <SSOProtectedRoute
              path="/purchase/preview/:contentId"
              component={ContentPreviewPage}
            />
            <SSOProtectedRoute
              path="/purchase/contents/:catalogId"
              component={CatalogContentList}
            />
            <SSOProtectedRoute
              path="/purchase/addins/details/:id"
              component={PurchaseAddInsDetailsPage}
            />
            <SSOProtectedRoute
              path="/purchase/my-addins/details/:id"
              component={PurchaseMyAddInsDetailsPage}
            />
          </SsoCartProvider>
          <SecureRoute
            exact
            path="/distributor/:id"
            component={DistributorProfile}
            routeData={UserTypes.distributor}
            auth={isAuth}
          />
          <SecureRoute
            exact
            path="/distributor/:id/:tabId"
            component={DistributorProfile}
            routeData={UserTypes.distributor}
            auth={isAuth}
          />
          <SecureRoute
            exact
            path="/distributor/:id/:tabId/:subTabId"
            component={DistributorProfile}
            routeData={UserTypes.distributor}
            auth={isAuth}
          />
          <SecureRoute
            exact
            path="/distributor"
            component={DistributorProfile}
            routeData={UserTypes.distributor}
            auth={isAuth}
          />
          <SecureRoute
            exact
            path="/distributors"
            component={Distributors}
            routeData={UserTypes.distributor}
            auth={isAuth}
          />
          <SecureRoute
            exact
            path="/enterprisegroup/:id"
            component={DistributorProfile}
            routeData={UserTypes.enterpriseGroupUser}
            auth={isAuth}
          />
          <SecureRoute
            exact
            path="/enterprisegroup/:id/:tabId"
            component={DistributorProfile}
            routeData={UserTypes.enterpriseGroupUser}
            auth={isAuth}
          />
          <SecureRoute
            exact
            path="/enterprisegroup/:id/:tabId/:subTabId"
            component={DistributorProfile}
            routeData={UserTypes.enterpriseGroupUser}
            auth={isAuth}
          />
          <SecureRoute
            exact
            path="/enterprisegroup"
            component={DistributorProfile}
            routeData={UserTypes.enterpriseGroupUser}
            auth={isAuth}
          />
          <SecureRoute
            exact
            path="/enterprisegroups"
            component={Distributors}
            routeData={UserTypes.enterpriseGroupUser}
            auth={isAuth}
          />
          <SecureRoute
            exact
            path="/subscriber"
            component={DistributorProfile}
            routeData={UserTypes.subscriber}
            auth={isAuth}
          />
          <SecureRoute
            exact
            path="/subscriber/:id"
            component={DistributorProfile}
            routeData={UserTypes.subscriber}
            auth={isAuth}
          />
          <SecureRoute
            exact
            path="/subscriber/:id/:tabId"
            component={DistributorProfile}
            routeData={UserTypes.subscriber}
            auth={isAuth}
          />
          <SecureRoute
            exact
            path="/subscribers"
            component={Distributors}
            routeData={UserTypes.subscriber}
            auth={isAuth}
          />
          <SecureRoute
            exact
            component={ReportPage}
            path="/Reports"
            auth={isAuth}
          />
          <SecureRoute
            exact
            component={ReportPage}
            path="/Reports/ad-performance"
            auth={isAuth}
          />
          <SecureRoute exact component={Access} path="/Access" auth={isAuth} />
          <SecureRoute
            exact
            component={Vendors}
            path="/vendors"
            auth={isAuth}
          />
          <SecureRoute
            exact
            component={AddEditIntSolution}
            path="/vendor/:vendorId/solution/new"
            auth={isAuth}
          />
          <SecureRoute
            exact
            component={AddEditIntSolution}
            path="/vendor/:vendorId/solution/:solutionId/:mode"
            auth={isAuth}
          />
          <SecureRoute
            exact
            component={AddEditVendor}
            path="/vendor/:id"
            auth={isAuth}
          />
          <SecureRoute
            exact
            component={AddEditVendor}
            path="/vendor"
            auth={isAuth}
          />
          <SecureRoute
            exact
            component={AddInsList}
            path="/AddInsList"
            auth={isAuth}
          />
          <SecureRoute
            exact
            component={AddInPayment}
            path="/payment"
            auth={isAuth}
          />
          <SecureRoute
            exact
            component={AddEditServices}
            path="/AddIns-Services/:id"
            auth={isAuth}
          />
          <SecureRoute
            exact
            component={AddEditServices}
            path="/AddIns-Services"
            auth={isAuth}
          />
          <SecureRoute
            exact
            component={AddInsServiceConfiguration}
            path="/add-ins/service/conifguration"
            auth={isAuth}
          />
          <SecureRoute
            exact
            component={AddInsServiceConfiguration}
            path="/add-ins/service/configuration"
            auth={isAuth}
          />
          <SecureRoute
            exact
            component={ManageRoles}
            path="/role-management"
            auth={isAuth}
          />
          <SecureRoute
            exact
            component={ManageModules}
            path="/module-management"
            auth={isAuth}
          />
          <SecureRoute
            exact
            component={ManageSettings}
            path="/settings"
            auth={isAuth}
          />
          <SecureRoute
            exact
            component={CatalogPage}
            path="/catalog"
            auth={isAuth}
          />
          <SecureRoute
            exact
            component={ContentPage}
            path="/content"
            auth={isAuth}
          />
          <SecureRoute
            exact
            component={BundlePage}
            path="/bundle"
            auth={isAuth}
          />
          <SecureRoute
            exact
            component={ApprovalRequests}
            path="/approvals"
            auth={isAuth}
          />
          <SecureRoute path="/users" component={Dashboard} auth={isAuth} />
          <SecureRoute
            exact
            path="/dashboard"
            component={LandingPage}
            auth={isAuth}
          />
          <SecureRoute
            exact
            path="/manage-documents"
            component={ManageDocuments}
            auth={isAuth}
          />
          <SecureRoute
            exact
            path="/confirm-approval/:id/:requestId"
            component={ConfirmApproval}
            auth={isAuth}
          />
          <SecureRoute
            exact
            path="/confirm-signup/:id/:requestId"
            component={ConfirmSignup}
            auth={isAuth}
          />
          <SecureRoute
            exact
            path="/adv-banners-formula"
            component={AdvBannersFormula}
            auth={isAuth}
          />
        </div>
      </div>
    </div>
  );
};

export default PrivateRoute;
